export function getIsMaxLevel(level: number) {
  return level >= 2;
}
